(function () {
    'use strict';

    document
        .querySelectorAll('.mol-header-mobile-nav div.atm-nav-link[data-nav-trigger]')?.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                const { navTrigger } = e.currentTarget.dataset;
                const currentNav = trigger.closest('ul');

                currentNav.style.transform = 'translateX(-100%)';

                setTimeout(() => {
                    currentNav.classList.remove('-active');
                    currentNav.style = '';

                    document
                        .querySelector(`[data-nav="${navTrigger}"]`)?.classList.add('-active');
                }, 100);
            });
        });

        document
        .querySelectorAll('.subitems-back')
        ?.forEach((backBtn) => {
            backBtn.addEventListener('click', (e) => {
                const currentNav = e.currentTarget.closest('ul');
    
                currentNav.style.transform = 'translateX(100%)';
    
                setTimeout(() => {
                    currentNav.classList.remove('-active');
                    currentNav.style = '';
    
                    document
                        .querySelector('.mol-header-mobile-nav > ul:first-of-type')
                        ?.classList.add('-active');
                }, 100);
            });
        });
})();